/**
 * @generated SignedSource<<0ab9e7a1a8e04e0fd21c53e1ce332aad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShippingDetailsPromo_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "ShippingDetailsPromo_item";
};
export type ShippingDetailsPromo_item$key = {
  readonly " $data"?: ShippingDetailsPromo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsPromo_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShippingDetailsPromo_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8cf16c3a1f3380c444a4aa6c0418c06a";

export default node;
